<span class="d-block text-center"><fa-icon [icon]="icons.spinner" [animation]="'spin'" class="me-1"></fa-icon> {{text()}}</span>
